(function() {
    'use strict';
    angular
        .module('telestatApp')
        .factory('RealtyType', RealtyType);

    RealtyType.$inject = ['$resource'];

    function RealtyType ($resource) {
        var resourceUrl =  'api/realty-types/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
